import { t as __t } from "i18next";
import React, { useState, useEffect, useRef } from "react";
import { notifyListRefresh } from "../../../utils/listNavigation";
import { useDispatch } from "react-redux";
import { callEditSpecialAgentCommision, callGetSpecialAgentCommisionById, callAddSpecialAgentCommision, callUploadFile, callSearchAgentInfo } from "../../../api/settings/service";
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import BackPrevious from "../../../components/back-previous";
import AgentAutoComplete from "../../../components/agent-auto-complete";
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import { convertStringToJson, handleInput, handleInvalid } from "../../../utils/commonUtil";
import { toast } from "react-toastify";
import "../../../components/i18n/lang";
import { decodeBase64, handleGetCookie } from "../../../utils/commonUtil"
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import colors from '../../../utils/colors'
import "../../style.css"
import FileUploadGrid from "../../../components/upload-file";

const Index = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [selectedFile, setSelectedFile] = useState(null);
	const [agentSpecial, setAgentSpecial] = useState({
		id: null,
		agentCode: '',
		firstName: '',
		lastName: '',
		commissionRate: '',
		updateBy: '',
		createdBy: '',
		documentPath: null,
		shortCommisionRate: '',
		isFocus: false
	});
	const fileInputRef = useRef(null);
	let params = useParams();

	useEffect(() => {
		if (Object.keys(params).length > 0) {
			let id = decodeBase64(params?.id)
			if (id != null) {
				getSepcialAgentCommissionById(id)
			}
		}
		const authData = handleGetCookie('auth');
		if (authData?.user?.userId) {
			setAgentSpecial((prev) => ({
				...prev,
				createdBy: authData?.user?.userId,
				updateBy: authData?.user?.userId,
			}));
		}
	}, []);

	const getSepcialAgentCommissionById = async (id) => {
		try {
			const rsp = await dispatch(callGetSpecialAgentCommisionById({ id }));
			if (rsp?.payload?.responseCode === "00000") {
				const item = rsp?.payload?.data
				console.log(item)
				setAgentSpecial((prev) => ({
					...prev,
					id: id,
					agentCode: item.agentCode,
					firstName: item.firstName,
					lastName: item.lastName,
					commissionRate: item.commissionRate,
					shortCommisionRate: item.shortCommisionRate,
					documentPath: item.documentPath ? convertStringToJson(item.documentPath) : []
				}));
			}


		} catch (error) {
			console.error(error)
		}
	};

	const handleChange = (e) => {
		const { name, value } = e.target;
		setAgentSpecial({
			...agentSpecial,
			[name]: value,
		});
	};

	const handleSave = async (e) => {
		e.preventDefault()

		Swal.fire({
			title: t("titleSave"),
			text: t("confirmSave"),
			icon: "warning",
			reverseButtons: true,
			showCancelButton: true,
			confirmButtonColor: colors.confirmMessage,
			cancelButtonColor: colors.cancel,
			confirmButtonText: t('confirm'),
			cancelButtonText: t('cancel')
		}).then(async (result) => {
			if (result.isConfirmed) {
				try {

					let docPath = null
					if (selectedFile !== null && agentSpecial.documentPath == null) {
						const upload = await dispatch(callUploadFile(selectedFile.file));
						if (upload?.payload?.responseCode === "00000") {
							docPath = JSON.stringify(upload?.payload?.data)
						}
					} else {
						docPath = JSON.stringify(agentSpecial.documentPath)
					}
					if (agentSpecial.id === null) {
						let req = {
							agentCode: agentSpecial.agentCode,
							commissionRate: agentSpecial.commissionRate,
							shortCommisionRate: agentSpecial.shortCommisionRate,
							createdBy: agentSpecial.createdBy,
							documentPath: docPath,
						}
						const res = await dispatch(callAddSpecialAgentCommision(req));
						console.log(res)
						if (res?.payload?.responseCode === "00000") {
							Swal.fire({
								icon: "success",
								title: t("success.add"),
								confirmButtonColor: colors.confirmMessage,
								confirmButtonText: t('close'),
							}).then(function () {
								notifyListRefresh();
								navigate(-1);
							});
						} else {
							toast.error(res?.payload?.responseCode + " - " + res?.payload?.responseDescription, {
								position: "top-left"
							})
						}
					} else {
						let req = {
							id: agentSpecial.id,
							agentCode: agentSpecial.agentCode,
							commissionRate: agentSpecial.commissionRate,
							shortCommisionRate: agentSpecial.shortCommisionRate,
							documentPath: docPath,
							updateBy: agentSpecial.updateBy,
						}
						const res = await dispatch(callEditSpecialAgentCommision(req));
						if (res?.payload?.responseCode === "00000") {
							Swal.fire({
								icon: "success",
								title: t("success.add"),
								confirmButtonColor: colors.confirmMessage,
								confirmButtonText: t('close'),
							}).then(function () {
								notifyListRefresh();
								navigate(-1);
							});
						} else {
							toast.error(res?.payload?.responseCode + " - " + res?.payload?.responseDescription, {
								position: "top-left"
							})
						}
					}
				} catch (error) {
					Swal.fire(__t("uiText.text023"), __t("uiText.text024"), "error");
				}
			}
		});
	}

	const triggerFileInput = () => {
		fileInputRef.current.click();
	};

	const handleImageSelect = (e) => {
		// if (file) {
		// const imageUrl = URL.createObjectURL(file);
		setSelectedFile({ file: e });
		// }
	};

	const cancelSeletedFile = () => {
		console.log("dsdsd")
		setSelectedFile(null);
		if (agentSpecial.documentPath !== null) {
			setAgentSpecial((prev) => ({
				...prev,
				documentPath: null,
			}));
		}
	};

	

	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<form onSubmit={handleSave}>
				<section className="user-dashboard">
					<div className="dashboard-outer">
						<div className="upper-title-box back-title-group">
							<BackPrevious />
							<h4>{agentSpecial.id === null ? t("settings.agentSpecialCommission.add") : t("settings.agentSpecialCommission.edit")}</h4>
						</div>

						<div className="ls-widget">
							<div className="tabs-box">
								<div className="widget-content p-4">
									<div className="default-form">
										<div className="row">
											<div className="col-md-3 form-group">
												<label> {t('settings.agentSpecialCommission.agentCode')} <span className="text-danger">*</span> </label>
												<AgentAutoComplete
													value={agentSpecial.agentCode}
													initialData={agentSpecial.agentCode}
													onSelect={(selectedAgent) => {
														setAgentSpecial((prev) => ({
															...prev,
															agentCode: selectedAgent.agentCode,
															firstName: selectedAgent.firstName,
															lastName: selectedAgent.lastName,
															isFocus: true
														}));

													}}
												/>
											</div>
											<div className="col-md-3 form-group">
												<label> {t('settings.agentSpecialCommission.firstName')} <span className="text-danger">*</span> </label>
												<input
													type="text"
													name="firstName"
													className="form-control-uld"
													placeholder={t('settings.agentSpecialCommission.firstName')}
													onInput={handleInput}
													onChange={handleChange}
													value={agentSpecial.firstName}
													autoComplete="off"
													readOnly />
											</div>
											<div className="col-md-3 form-group">
												<label> {t('settings.agentSpecialCommission.lastName')}</label>
												<input
													type="text"
													name="lastName"
													className="form-control-uld"
													placeholder={t('settings.agentSpecialCommission.lastName')}
													onInput={handleInput}
													onChange={handleChange}
													value={agentSpecial.lastName}
													readOnly
													autoComplete="off"
												/>
											</div>

											<div className="col-md-3 form-group">
												<label> {t('settings.agentSpecialCommission.commission')} %<span className="text-danger">*</span> </label>
												<input
													type="number"
													name="commissionRate"
													className="form-control-uld"
													placeholder={t('settings.agentSpecialCommission.commission') + "%"}
													onInput={handleInput}
													onChange={handleChange}
													value={agentSpecial.commissionRate}
													autoComplete="off"
													autoFocus={agentSpecial.isFocus}
													max={100}
													required />
											</div>
											<div className="col-md-3 form-group">
												<label> {t('settings.agentSpecialCommission.shortCommission')} %<span className="text-danger">*</span> </label>
												<input
													type="number"
													name="shortCommisionRate"
													className="form-control-uld"
													placeholder={t('settings.agentSpecialCommission.shortCommission') + "%"}
													onInput={handleInput}
													onChange={handleChange}
													value={agentSpecial.shortCommisionRate}
													autoComplete="off"
													max={100}
													required />
											</div>

											<div className="col-12 col-md-12 form-group">
												<label> {t('settings.agentSpecialCommission.documentReference')} <span className="text-danger">*</span> </label>
												<FileUploadGrid
													multiple={false}
													folderName="sepcial_agents"
													filesFromApi={agentSpecial.documentPath || []}
													onChange={handleImageSelect}
													accept="image/*"
													required
												/>
											</div>

											<div className="col-12 d-flex justify-content-center">
												<div className="m-3">
													<button className="theme-btn btn-style-one w-100" type="submit">
														<i className="fas fa-add"></i>&nbsp;{t("button.save")}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</form>
			<CopyrightFooter />
		</div>
	);
};

export default Index;
